import type { BootstrapData, RequestInput, RequestKind, RequestOptions } from "@czasomat/contracts";
import { ApiError } from "./api/client";
import { operationEmployees } from "./operations-support";

export const requestKindLabels: Record<RequestKind, string> = {
  leave: "Urlop", hr: "Kadrowy", custom: "Dowolny", rcp_correction: "Korekta RCP", schedule_swap: "Zamiana grafiku", delegation: "Delegacja"
};
export type RequestDraft = {
  employeeId: string; kind: RequestKind; typeId: string; recipientUserId: string;
  from: string; to: string; note: string; clientRequestId: string;
};
export function newRequestDraft(employeeId: string, today: string): RequestDraft {
  return { employeeId, kind: "leave", typeId: "", recipientUserId: "", from: today, to: today, note: "", clientRequestId: crypto.randomUUID() };
}
function realDate(value: string) {
  const epoch = Date.parse(`${value}T00:00:00Z`);
  return /^\d{4}-\d{2}-\d{2}$/.test(value) && !value.startsWith("0000") && Number.isFinite(epoch) && new Date(epoch).toISOString().slice(0, 10) === value;
}
export function requestDraftPayload(draft: RequestDraft, options: RequestOptions): RequestInput {
  if (options.employeeId !== draft.employeeId || options.kind !== draft.kind || options.flow.kind !== draft.kind || !options.flow.active) throw new Error("Pobierz aktualne opcje dla wybranego pracownika i rodzaju wniosku.");
  if (!options.recipients.some((person) => person.id === draft.recipientUserId)) throw new Error("Wybierz dostępnego adresata wniosku.");
  if (draft.kind === "leave" && !options.types.some((type) => type.id === draft.typeId)) throw new Error("Wybierz dostępny typ urlopu.");
  if (!realDate(draft.from) || !realDate(draft.to) || draft.from > draft.to) throw new Error("Podaj poprawny zakres rzeczywistych dat.");
  return { employeeId: draft.employeeId, kind: draft.kind, ...(draft.kind === "leave" ? { typeId: draft.typeId } : {}),
    from: draft.from, to: draft.to, note: draft.note, recipientUserId: draft.recipientUserId,
    approvalFlowRevision: options.flow.revision, clientRequestId: draft.clientRequestId };
}
export function definiteRequestRejection(error: unknown): boolean {
  return error instanceof ApiError && error.status >= 400 && error.status < 500 && ![408, 425, 429].includes(error.status);
}
export function requestEmployeeName(data: BootstrapData, request: Record<string, any>): string {
  const employee = data.employees.find((person) => person.id === request.employeeId);
  return employee ? `${employee.firstName} ${employee.lastName}` : request.employeeName || "Osoba niedostępna w kartotece";
}

export function requestEmployees(data: BootstrapData): Array<{ id: string; name: string }> {
  const employees = operationEmployees(data, "requests.decide").map((employee) => ({ id: employee.id, name: `${employee.firstName} ${employee.lastName}` }));
  if (data.auth.employeeId && !employees.some((employee) => employee.id === data.auth.employeeId)) employees.push({ id: data.auth.employeeId, name: "Osoba przypisana do mojego konta" });
  return employees;
}
